export const DEV_CDN = 'https://dev.cdn.lumapps.com/';
export const PROD_CDN = 'https://prod.cdn.lumapps.com/';
